import { bigQuery, mixpanel } from '@fiverr-private/perseus';
import { MIXPANEL_EVENT_TYPES } from '../types/mixpanelEventTypes';
import { DEFAULT_DATA } from './events/defaultData';
import * as mp from './events/mixPanelEvents';
import * as bq from './events/bigQueryEvents';
import { PAGE_NAME } from './constants';

export const sendBigQueryEvent = ({ eventName, params = {} }) => {
    let eventData = {
        type: eventName,
        group: PAGE_NAME
    };

    switch (eventName) {
        case bq.BQ_CLICKED_GUEST_HOMEPAGE_CATEGORY_IMAGE:
            eventData = {
                ...eventData,
                category: {
                    id: params.id,
                    name: params.name
                },
                position: params.position
            };
            break;
        case bq.BQ_CLICKED_HOMEPAGE_LO_SEARCH_TAG:
            eventData = {
                ...eventData,
                ...params
            };
            break;
        case bq.BQ_CLICKED_HOMEPAGE_LO_CARD_MADE_ON_FIVERR:
            eventData = {
                ...eventData,
                position: params.pos,
                page: {
                    element: {
                        type: params.type,
                        text: params.item.subCategory.name
                    }
                },
                category: {
                    id: params.item.category.id,
                    name: params.item.category.slug
                },
                sub_category: {
                    id: params.item.subCategory.id,
                    name: params.item.subCategory.slug
                },
                seller: {
                    id: params.item.seller.id
                },
                gig: {
                    id: params.item.gig.id
                }
            };
            break;
        default:
            break;
    }

    bigQuery.send(eventData);
};

export const sendMixPanelEvent = ({
    eventName,
    eventType = MIXPANEL_EVENT_TYPES.STANDARD,
    params = {}
}) => {
    let eventData = DEFAULT_DATA;

    switch (eventName) {
        case mp.CLICKED_POPULAR_SEARCH_TAG:
            eventData = {
                ...eventData,
                'Tag Name': params.name,
                'Tag Order': params.order
            };
            break;
        case mp.CLICKED_TESTIMONIALS_VIDEO:
            eventData = {
                ...eventData,
                'Testimonial Order': params.order
            };
            break;
        case mp.CLICKED_MARKETING_GUIDE:
            eventData = {
                ...eventData,
                'Guide Name': params.name,
                'Guide Order': params.order
            };
            break;
        case mp.CLICKED_BANNER_SEARCH:
            eventData = {
                ...eventData,
                'Query': params.query,
                'Price': params.price,
                'Delivery': params.delivery
            };
            break;
        default:
            break;
    }

    if (eventType === MIXPANEL_EVENT_TYPES.PAGE_VIEW) {
        mixpanel.trackPageView({
            'Page Name': eventName,
            ...eventData
        });
    } else {
        mixpanel.track(eventName, eventData);
    }
};
